// extracted by mini-css-extract-plugin
export default {"wrapper":"UiVerificationCodeInput_wrapper","input":"UiVerificationCodeInput_input"};